import { Segment, Type, CronType } from './../enums';
import { CronUIBaseService } from './ui-base.service';
export class CronUnixUIService extends CronUIBaseService {
    constructor() {
        super(...arguments);
        this.api = {
            [Type.MINUTES]: this.getCommonApi(Segment.minutes),
            [Type.HOURS]: this.getCommonApi(Segment.hours),
            [Type.MONTH]: this.getCommonApi(Segment.month),
            [Type.DAY]: this.getDayApi()
        };
        this.cronType = CronType.UNIX;
    }
    getApi(type) {
        const api = this.api[type];
        return api ? Object.assign({}, api) : null;
    }
}
